var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.23486,
    y: 0.5,
    width: 49,
    height: 51,
    rx: 9.5,
    stroke: "#D4D4D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9145 28.0641C21.789 28.0641 19.1575 28.0649 17.9437 28.0637C17.3189 28.0633 17.096 27.8388 17.096 27.21C17.0952 25.5947 17.0948 23.9795 17.096 22.3643C17.0964 21.7434 17.3321 21.5065 17.9489 21.5061C19.1626 21.5053 21.7798 21.5057 21.9145 21.5057C21.9145 21.3951 21.9141 19.0631 21.9145 17.9892C21.9153 16.4016 22.1985 14.8818 23.0051 13.4903C23.8309 12.0661 25.0327 11.0905 26.5728 10.5264C27.5592 10.1648 28.5831 10.0206 29.6298 10.0198C30.9394 10.019 32.249 10.0202 33.559 10.0226C34.122 10.0234 34.3716 10.2723 34.3728 10.8392C34.3752 12.3585 34.3752 13.8779 34.3728 15.3968C34.372 15.9697 34.1327 16.1998 33.557 16.2062C32.4836 16.2178 31.4093 16.2106 30.337 16.2538C29.2539 16.2538 28.6842 16.7827 28.6842 17.9037C28.6582 19.0895 28.6734 20.2764 28.6734 21.5053C28.7749 21.5053 31.8571 21.5049 33.2978 21.5053C33.9522 21.5053 34.1759 21.7303 34.1759 22.3883C34.1759 23.9947 34.1755 25.6015 34.1743 27.208C34.1739 27.8564 33.9637 28.0633 33.3053 28.0637C31.8647 28.0645 28.7945 28.0641 28.6602 28.0641V41.0662C28.6602 41.7594 28.4421 41.9803 27.7581 41.9803C26.0906 41.9803 24.4226 41.9807 22.7551 41.9803C22.1506 41.9803 21.9149 41.7454 21.9149 41.1409C21.9145 36.9065 21.9145 28.2127 21.9145 28.0641Z",
    fill: "#3D6AD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.37bc7bde6e8597e19503463f46e627e4.svg";
export { ForwardRef as ReactComponent };